import { create } from 'zustand';
import api from '../lib/api';
import type { UserListItem } from '../types';

interface UserState {
  users: UserListItem[];
  isLoading: boolean;
  error: string | null;
  fetchUsers: () => Promise<void>;
}

export const useUserStore = create<UserState>((set, get) => ({
  users: [],
  isLoading: false,
  error: null,

  fetchUsers: async () => {
    // Skip if already loaded
    if (get().users.length > 0) return;

    try {
      set({ isLoading: true, error: null });
      const response = await api.get('/api/users');
      set({
        users: response.data.users,
        isLoading: false,
      });
    } catch (error: any) {
      console.error('Failed to fetch users:', error);
      set({
        isLoading: false,
        error: error.response?.data?.message || 'Failed to load users',
      });
    }
  },
}));
